__webpack_require__.p = "/web-pdp-scaffold-ui/_next/";